package fr.labodoc.healthProfessional.api.resources

import io.ktor.resources.*

@Resource("departments")
class Departments
